export default "__VITE_ASSET__Dknp9D5C__"